import _createClass from "/Users/anitalu/Desktop/internship/anitalu724.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/anitalu/Desktop/internship/anitalu724.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var ExternalInteractorBase = /*#__PURE__*/_createClass(function ExternalInteractorBase(container) {
  _classCallCheck(this, ExternalInteractorBase);

  this.container = container;
  this.type = 0;
});